import { graphql } from "gatsby"
import React from "react"

import ProductGroupCard from "../components/Cards/ProductGroupCard"
import LocalizedProductLink from "../components/common/LocalizedProductLink"
import Hero, { colors } from "../components/Hero/Hero"
import Layout from "../components/Layout"
import SEO from "../components/seo"
import {
  selectMenuPageContent,
  selectProductGroups,
  selectTranslations,
} from "../graphql/selectors"
import s from "./menu.module.scss"

export default function MenuPage(props) {
  const { data, pageContext } = props
  const { langCode, localePath, pagePathsByLangCode } = pageContext
  const translations = selectTranslations(data)
  const groups = selectProductGroups(data)
  const { seo, hero } = selectMenuPageContent(data)

  return (
    <Layout
      className={s.menuPage}
      i18n={{ ...translations, localePath }}
      langCode={langCode}
      pagePathsByLangCode={pagePathsByLangCode}
      productGroups={selectProductGroups(data)}
    >
      <SEO {...seo} lang={langCode} />
      <Hero
        color={colors.dark}
        title={hero.title}
        titleColor="bright"
        variation="narrow"
      />
      <div className={s.content}>
        <div className={s.categoriesList}>
          {groups.map(({ slug, name, imageUrl }) => {
            return (
              <div className={s.category} key={slug}>
                <LocalizedProductLink
                  className={s.categoryLink}
                  productGroupSlug={slug}
                >
                  <ProductGroupCard imageUrl={imageUrl} name={name} />
                </LocalizedProductLink>
              </div>
            )
          })}
        </div>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query MenuPage($locale: String) {
    ...LayoutFragment
    ...MenuPageFragment
  }
`
